import { useState, useEffect } from "react";
import useContent from "../lib/useContent";

const DEFAULT_SLIDES = [
  { img: "https://images.unsplash.com/photo-1772949399823-dcd1678fcce7?w=2200", overline: "Curated Horology · Est. 2026", title: "Mastery in Motion.", sub: "A private boutique for the world's most coveted timepieces. Authenticated, fully warrantied, delivered with discretion.", cta: "Shop the Collection", href: "/shop" },
  { img: "https://images.pexels.com/photos/15019857/pexels-photo-15019857.jpeg?auto=compress&cs=tinysrgb&w=2200", overline: "New Arrivals", title: "The Latest Pieces.", sub: "Just acquired — fresh additions from Geneva, Le Sentier, and Glashütte.", cta: "Discover New", href: "/shop?featured=true" },
  { img: "https://images.pexels.com/photos/22032441/pexels-photo-22032441.jpeg?auto=compress&cs=tinysrgb&w=2200", overline: "Limited Edition", title: "Rare. Coveted. Yours.", sub: "Handpicked exclusive limited-edition timepieces from the world's most revered manufactures.", cta: "View Limited", href: "/shop" },
  { img: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=2200", overline: "Worldwide Shipping", title: "Insured · Discreet · Swift.", sub: "Complimentary insured worldwide shipping on every order above AED 5,000.", cta: "Read Policy", href: "/p/shipping" },
];

export default function HeroCarousel() {
  const { data } = useContent("homepage_hero", { items: DEFAULT_SLIDES });
  const slides = (data?.items?.length ? data.items : DEFAULT_SLIDES);
  const [i, setI] = useState(0);
  useEffect(() => { setI(0); }, [slides.length]);
  useEffect(() => {
    if (slides.length <= 1) return;
    const t = setInterval(() => setI((p) => (p + 1) % slides.length), 6000);
    return () => clearInterval(t);
  }, [slides.length]);

  return (
    <section className="relative h-[78vh] min-h-[560px] overflow-hidden bg-black">
      {slides.map((s, idx) => (
        <div key={idx} className="absolute inset-0 transition-opacity duration-1000" style={{ opacity: i === idx ? 1 : 0 }}>
          <img src={s.img} alt={s.title} onError={(e) => { e.currentTarget.src = "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=2200"; }} className="w-full h-full object-cover"/>
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent"/>
          <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12 h-full flex items-center">
            <div className="max-w-2xl">
              {s.overline && <div className="text-[11px] uppercase tracking-luxe font-semibold text-copper mb-5">{s.overline}</div>}
              <h1 className="font-display text-5xl md:text-7xl lg:text-8xl text-white leading-[0.95] tracking-tight">{s.title}</h1>
              {s.sub && <p className="text-base md:text-lg text-white/80 mt-7 max-w-lg leading-relaxed font-light">{s.sub}</p>}
              {s.cta && <a href={s.href || "/shop"} data-testid={`hero-cta-${idx}`} className="btn-gold mt-10">{s.cta}</a>}
            </div>
          </div>
        </div>
      ))}
      {slides.length > 1 && (
        <div className="absolute bottom-8 right-6 md:right-12 z-20 flex gap-2">
          {slides.map((_, idx) => (
            <button key={idx} data-testid={`hero-dot-${idx}`} onClick={() => setI(idx)} className={`h-1 transition-all ${i === idx ? "w-8 bg-copper" : "w-4 bg-white/40 hover:bg-white/70"}`} />
          ))}
        </div>
      )}
    </section>
  );
}
